import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons';
import { getPublicDashboardToken } from '../../../services/dashboardApi';

const cellStyle = {
  maxWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const AlertNameCell = ({ alert, isTriggered }) => {
  const isPublicView = !!getPublicDashboardToken();
  const content = (
    <>
      {isTriggered && (
        <FontAwesomeIcon icon={faBolt} className="text-warning mr-1" />
      )}
      {alert.description}
    </>
  );

  return (
    <td className="align-middle" style={cellStyle} title={alert.description}>
      {isPublicView || alert.id == null ? (
        content
      ) : (
        <a href={`/s/alerts/${alert.id}`}>{content}</a>
      )}
    </td>
  );
};

AlertNameCell.propTypes = {
  alert: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.string,
  }).isRequired,
  isTriggered: PropTypes.bool.isRequired,
};

export default AlertNameCell;
